import MuiAlert from "@mui/material/Alert";

function AlertComponent (props) {
  const { message, handleClose = () => {}, typeAlert = 'success' } = props;
  
  return (
    <MuiAlert
      onClose={handleClose}
      severity={typeAlert}
      sx={{ 
        fontSize: '1.2rem',
        padding: '1rem',
        mb: 2, 
        '& .MuiAlert-message': {
          fontSize: '1.2rem',
          fontWeight: 500,
        },
        '& .MuiAlert-icon': {
          fontSize: '1.5rem',
        },
      }}
    >
      {message}
    </MuiAlert>
  );
}

export default AlertComponent;
